/**
 * @generated SignedSource<<786b6ef6788482dcbe1388caf886e47c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BookingStatus = "CONFIRMED" | "DRAFT";
import { FragmentRefs } from "relay-runtime";
export type BookingSummaryMultipleView_booking$data = {
  readonly __typename: string;
  readonly id: string;
  readonly ownerClient: {
    readonly id?: string;
  } | null | undefined;
  readonly restrictionStatuses?: {
    readonly groupStatuses: {
      readonly statuses: ReadonlyArray<{
        readonly restriction: {
          readonly name: string;
        };
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly roundStatuses: ReadonlyArray<{
      readonly statuses: ReadonlyArray<{
        readonly restriction: {
          readonly name: string;
        };
      } | null | undefined> | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly startSlot: {
    readonly agenda: {
      readonly facility: {
        readonly club: {
          readonly phoneNumber: {
            readonly formattedNumber: string;
          } | null | undefined;
          readonly supportsPrivate: boolean;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"RemoteLockCode_BookingSummaryRemoteLockCodeConfig">;
      };
    };
    readonly id: string;
  } | null | undefined;
  readonly status?: BookingStatus;
  readonly " $fragmentSpreads": FragmentRefs<"BookingConfirmedModal_Booking" | "BookingDetailsView_Booking" | "BookingHeaderFragment_booking" | "BookingInfo_Booking" | "BookingPaymentMethodSelect_booking" | "BookingPayment_Booking" | "BookingPolicy_Booking" | "BookingReservation_Booking" | "ChargesSummary_booking" | "InviteOthersBox_Booking" | "MemberNote_Booking" | "PaymentCardEntryModals_booking" | "RemoteLockCode_Booking" | "RequestInfoBanner_booking" | "useGetBookingAnalyticsMetadata_booking" | "useShouldPresentBookingAsLockedRequest_booking">;
  readonly " $fragmentType": "BookingSummaryMultipleView_booking";
};
export type BookingSummaryMultipleView_booking$key = {
  readonly " $data"?: BookingSummaryMultipleView_booking$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookingSummaryMultipleView_booking">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "patronLoyalty",
    "variableName": "patronLoyalty"
  }
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "RestrictionStatus",
    "kind": "LinkedField",
    "name": "statuses",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "restriction",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "status",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "concreteType": "BookingRuleStatuses",
    "kind": "LinkedField",
    "name": "restrictionStatuses",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "GroupBookingRuleStatus",
        "kind": "LinkedField",
        "name": "groupStatuses",
        "plural": false,
        "selections": (v2/*: any*/),
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "RoundBookingRuleStatus",
        "kind": "LinkedField",
        "name": "roundStatuses",
        "plural": true,
        "selections": (v2/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  (v0/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "patronLoyalty"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookingSummaryMultipleView_booking",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useGetBookingAnalyticsMetadata_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RemoteLockCode_Booking"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "ChargesSummary_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PaymentCardEntryModals_booking"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "BookingPayment_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "InviteOthersBox_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingInfo_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingDetailsView_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingPolicy_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingPaymentMethodSelect_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingConfirmedModal_Booking"
    },
    {
      "args": (v1/*: any*/),
      "kind": "FragmentSpread",
      "name": "BookingReservation_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BookingHeaderFragment_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MemberNote_Booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "RequestInfoBanner_booking"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShouldPresentBookingAsLockedRequest_booking"
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "StandardBooking",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v3/*: any*/),
      "type": "LessonBooking",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "ownerClient",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": (v4/*: any*/),
          "type": "Customer",
          "abstractKey": null
        },
        {
          "kind": "InlineFragment",
          "selections": (v4/*: any*/),
          "type": "Member",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "startSlot",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Agenda",
          "kind": "LinkedField",
          "name": "agenda",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Facility",
              "kind": "LinkedField",
              "name": "facility",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Club",
                  "kind": "LinkedField",
                  "name": "club",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "supportsPrivate",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "PhoneNumber",
                      "kind": "LinkedField",
                      "name": "phoneNumber",
                      "plural": false,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "formattedNumber",
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "RemoteLockCode_BookingSummaryRemoteLockCodeConfig"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Booking",
  "abstractKey": "__isBooking"
};
})();

(node as any).hash = "4fc906b3f6373ad7c0700cb4313e2402";

export default node;
